import { appearanceKey } from '../textures/javaModels';
import type { StructureModel } from '../nbt/types';
import { buildAtlas, type SourceTexture, type TextureAtlas } from '../textures/atlas';
import { blockAppearance, type BlockAppearance } from '../textures/blockAppearance';

export interface ResourcePackTextures {
  name: string;
  tile: number;
  textures: Map<string, SourceTexture>;
  appearances?: Map<string, BlockAppearance>;
  previews?: Map<string, BlockAppearance>;
  /** Material-only item IDs mapped to their flat inventory texture. */
  itemIcons?: Map<string, string>;
  unsupported?: string[];
  catalogSize?: number;
}

export interface StructureAssets {
  appearances: BlockAppearance[];
  atlas: TextureAtlas;
  /** 建築に使われているテクスチャの種類数。 */
  textureCount: number;
}

/** 建築が使うテクスチャ名を列挙する。リソースパックから読むファイルを絞るために使う。 */
export function collectTextureNames(model: StructureModel): string[] {
  const names = new Set<string>();
  model.palette.forEach((entry) => {
    blockAppearance(entry.name, entry.properties).faces.forEach((face) => names.add(face));
  });
  return [...names];
}

/** パレットの各エントリから見た目を決め、必要なテクスチャだけをアトラスへ詰める。 */
export function buildStructureAssets(model: StructureModel, pack?: ResourcePackTextures | null): StructureAssets {
  const appearances = model.palette.map((entry) => pack?.appearances?.get(appearanceKey(entry.name, entry.properties)) ?? blockAppearance(entry.name, entry.properties));
  const names = new Set<string>();
  appearances.forEach((appearance) => appearanceTextureNames(appearance).forEach((face) => names.add(face)));

  const sources = new Map<string, SourceTexture>();
  if (pack) {
    names.forEach((name) => {
      const texture = pack.textures.get(name);
      if (texture) sources.set(name, texture);
    });
  }

  const atlas = buildAtlas(names, { tile: pack?.tile, sources });
  return { appearances, atlas, textureCount: names.size };
}

export function appearanceTextureNames(appearance: BlockAppearance): string[] {
  return appearance.quads ? [...new Set(appearance.quads.map((quad) => quad.texture))] : [...new Set(appearance.faces)];
}
